import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { withRouter,useHistory,NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import GpsFixedOutlinedIcon from '@material-ui/icons/GpsFixedOutlined';
import { connect } from 'react-redux';
import { numberFormat, getDateInStringDDMMMYYYY, getDisplayName, getRequestTimeInMillis } from "../../../utils/utils";
import ConfirmDialog from '../Dialog/ConfirmDialog';
import {
    getTripDetailsV3,
    deleteVendorExpense,
    deletePartyAdvance
} from "../../../store/actions/tripActionCreator";
import {sendError, sendSucces} from "../../../utils/utils"
const useStyles = makeStyles((theme) => ({
    info: {
      padding: 24,
      backgroundColor:'#d6def7',
      height:'100%',
      minHeight:100,
      maxHeight:100,
      borderRadius:8,
      display:'flex',
      flexDirection: 'row',
      color:'#0033cc',
      alignItems:'center',
      fontWeight:300
    }
}));
const DeletePartyAdvance = (props) => {
  const {location,tripId,deleteId,deleteOpen,dispatchTripDetailsAction,dispatchDeletePartyAdvance,onDeleteSucees,onDeleteNo} = props;
  const classes = useStyles();
  let history = useHistory();
  const [open, setOpen] = React.useState(deleteOpen);
  let confirmMessage ="Are you sure Want to Delete Party Advance?";
  let confirmTitle ="Delete Party Advance";
  const fetchTrip = (tripId)=>{
    dispatchTripDetailsAction(tripId, () => {
    });
  }
  const onConfirm = (confirm)=>{
    if (confirm) {
      dispatchDeletePartyAdvance(tripId,deleteId,(response)=>{
        if(response && response.status && response.status && response.status.code && response.status.code=== 200){
            sendSucces("Party Advance Deleted Suceessfully!");
            onDeleteSucees()
        }else{
        }
        },
        ()=>{
        })
    } else {
        onDeleteNo()
        //fetchTrip(tripId) 
    }
  }
  return (
    <>
{open && <ConfirmDialog confirmOpen={open} confirmTitle={confirmTitle} confirmMessage={confirmMessage} onClose={onConfirm} />
}    </>
  );
}
DeletePartyAdvance.propTypes = {
    tripId: PropTypes.any.isRequired,
};
const DeletePartyAdvanceWithRouter = withRouter(DeletePartyAdvance);
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
  dispatchTripDetailsAction: (tripId, onSuccess,onError) =>
    dispatch(getTripDetailsV3(tripId,onSuccess,onError)),
  dispatchDeletePartyAdvance: (tripId,advanceId,onSuccess,onFailure) => dispatch(deletePartyAdvance(
    tripId,
    advanceId, 
    null, 
    onSuccess,
    onFailure
  )),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeletePartyAdvanceWithRouter);